import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging } from "firebase/messaging";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import { API_CONFIG } from "./api";

// Firebase web config is not a secret (it identifies the project; access is
// governed by Firebase Security Rules), so shipping it in the bundle is the
// normal, documented way to initialise a Firebase web app. Set per environment
// via .env — see REACT_APP_FIREBASE_* there.
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY as string,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN as string,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID as string,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET as string,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID as string,
    appId: process.env.REACT_APP_FIREBASE_APP_ID as string,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID as string,
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const messaging = getMessaging(app);
const storage = getStorage(app);
const db = getFirestore(app);

// Matches the Flutter app: 'staging' when pointed at localhost/stagging URL, else 'production'
const baseUrl = API_CONFIG.getBaseUrl();
export const storageEnv =
    baseUrl.includes("localhost") || baseUrl.includes("127.0.0.1") || baseUrl.includes("0.0.0.0") || baseUrl.includes("stagging")
        ? "staging"
        : "production";

export { app, analytics, messaging, storage, db };
